import React, { useState } from 'react'
import styled from 'styled-components'
import * as vars from '../variables'

const Subscribe = () => {
  const [subscribeDropDown, setSubscribeDropDown] = useState(false)

  const subscribeClick = () => {
    setSubscribeDropDown(!subscribeDropDown)
  }

  return (
    <StyledSubscribe>
      <div className="subscribe">
        <button
          className={
            subscribeDropDown ? 'subscribe-btn is-active' : 'subscribe-btn'
          }
          onClick={subscribeClick}
          aria-label="Subscribe to Mailing List"></button>
        <div
          className={
            subscribeDropDown ? 'mailchimpSub is-active' : 'mailchimpSub'
          }>
          <form
            action="//emiledrescher.us6.list-manage.com/subscribe/post?u=16ee30e5405506b147ce76316&amp;id=03618d750a"
            method="post"
            name="mc-embedded-subscribe-form"
            className="validate"
            target="_blank"
            noValidate="">
            <label className="email-field">
              {' '}
              Email address
              <input
                className="required email"
                name="EMAIL"
                size="30"
                type="email"
                placeholder="Enter your email"></input>
            </label>
            <label className="button-field">
              <input
                className="button"
                name="subscribe"
                type="submit"
                value="Enter"
                onClick={() => {
                  window.dataLayer.push({ 'event': 'subscribe_click' })
                  setSubscribeDropDown(false)
                }}></input>
            </label>
          </form>
        </div>
      </div>
      <div
        className={
          subscribeDropDown ? 'sub-close-area is-active' : 'sub-close-area'
        }
        onClick={subscribeClick}></div>
    </StyledSubscribe>
  )
}

export default Subscribe

const StyledSubscribe = styled.div`
  .subscribe {
    position: relative;
    padding: 0 50px;
    z-index: 2;

    font-size: 14px;
    text-transform: uppercase;
    @media only screen and (max-width: 1000px) {
      padding: 0 30px;
    }
    @media only screen and (max-width: ${vars.mobile}) {
      position: absolute;
      right: 0px;
      padding: 20px 0 0;
      width: 100%;
      font-size: 14px;
      text-transform: uppercase;
    }

    .subscribe-btn {
      background-color: transparent;
      border: 0;
      right: 0;
      width: 80px;
      outline: none;
      color: black;
      font-weight: normal;
      text-transform: uppercase;
      padding: 0;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }

      @media only screen and (max-width: ${vars.mobile}) {
        font-size: 14px;
        background-color: transparent;
        border: 0;
        right: 15px;
        width: 80px;
        outline: none;
        position: absolute;
        color: black;
        font-weight: normal;
        text-transform: uppercase;
        text-align: right;
        padding: 0;
      }

      &:before {
        content: 'Subscribe';
      }

      &.is-active {
        &:before {
          content: 'Close';
        }
      }
    }
  }

  .mailchimpSub {
    font-family: galvji;
    background: white;
    height: 32px;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 50%;
    width: 300px;
    opacity: 0;
    pointer-events: none;
    transform: translateY(-50%);
    transition: opacity 0.3s ease-out;

    label {
      overflow: visible;

      input {
        box-sizing: border-box;
        height: 32px;
      }

      &.email-field {
        flex-grow: 1;
      }

      &.button-field {
        width: 80px;

        .button {
          justify-content: center;
        }
      }

      visibility: hidden;
      input {
        visibility: visible;
      }
    }

    &.is-active {
      opacity: 1;
      pointer-events: all;
      transform: translateY(-50%);

      @media only screen and (max-width: ${vars.mobile}) {
        transform: none;
      }
    }

    form {
      display: flex;
      flex-direction: row;
      height: 100%;
      position: relative;
    }

    @media only screen and (max-width: ${vars.mobile}) {
      position: absolute;
      top: 12px;
      right: 10px;
      left: 10px;
      width: auto;
      transform: none;
      height: 32px;
    }
  }

  .mailchimpSub label input {
    border: medium none;
    color: black;
    border: 1px solid #dfdfdf;
    margin-bottom: 10px;
    padding: 8px 10px;
    font-family: galvji;
    position: absolute;
  }

  .mailchimpSub label input.email {
    flex-grow: 1;
    background: #fff;
    border-right: 0;
    width: 100%;
    left: 0;
  }
  .mailchimpSub label input[type='submit'] {
    background: #fff;
    color: #black;
    cursor: pointer;
    font-size: 14px;
    width: 80px;
    padding: 8px 0;
    line-height: 0;
    border-radius: 0;
    text-transform: uppercase;
    right: 0;
  }

  ::-webkit-input-placeholder {
    color: gray;
  }

  .sub-close-area {
    z-index: 1;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: transparent;
    opacity: 0;
    transition: 0.3s opacity ease-out;
    pointer-events: none;

    &.is-active {
      opacity: 1;
      pointer-events: all;
    }
  }
`
